module.exports = __webpack_public_path__ + "static/media/176-lesotho.5da5e37c.svg";